export default __webpack_public_path__ + "static/media/tigerbox_touch_logo.8c1b51a1.png";